import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  @media screen and (max-width: 768px) {\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import Svg from "../Svg";
var CsSvg = styled(Svg).withConfig({
    componentId: "sc-2d1f6c4-0"
})(_templateObject());
var Icon = function(_param) {
    var color = _param.color, height = _param.height, props = _object_without_properties(_param, [
        "color",
        "height"
    ]);
    return(// <CsSvg width="100%" height="600px" viewBox="0 0 1440 354" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    //   <path
    //     d="M1460.6 134.9V0.5H-21.0016V95.7399C-9.59583 176.847 121.494 341.799 554.608 352.749C987.721 363.698 1339.07 212.078 1460.6 134.9Z"
    //     fill={color}
    //   />
    // </CsSvg>  
    /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        width: "100%",
        height: "802",
        viewBox: "0 0 2560 802",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            d: "M2560 428.417V0H0V364.359C19.7075 497.035 246.212 783.223 994.57 801.134C1742.93 819.045 2350.01 554.666 2560 428.417Z",
            fill: color
        })
    })));
};
export default Icon;
